import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ImageService, Image } from '../../services/image.service';
import { Router, ActivatedRoute, Params, ActivatedRouteSnapshot } from '@angular/router';

@Component({
	selector: 'app-media-selector',
	templateUrl: './media-selector.component.html',
	styleUrls: ['./media-selector.component.less']
})
export class MediaSelectorComponent implements OnInit {
	images: any[];
	error: any;
	cur_image;
	@Output() onSelect = new EventEmitter<Image>();

	constructor(
		private imageService: ImageService,
		private route: ActivatedRoute
	) { }

	ngOnInit() {
		this.imageService.getImages().subscribe(images => {
			this.images = images.sort((a, b) => {
                if (a.created_at == b.created_at) {
                    return 0;
                }
                return a.created_at > b.created_at ? -1 : 1;
            });
		});
	}

	imgOnClick(image: Image) {
		this.cur_image = image;
	}

	select(image: Image) {
		this.onSelect.emit(image);
	}

	onDelete(name, key) {
		if (confirm('Are you sure?')) {
			this.imageService.deleteImage(name, key);
			this.cur_image = '';
		}
	}

	upload() {
		var uploader = document.getElementsByClassName('progress-bar')[0];
		var progress = document.getElementsByClassName('progress')[0];
		var alert = document.getElementById('hidden');
		var target = (<HTMLInputElement>document.getElementById('image'));
		var file_name_element = <HTMLDivElement>document.getElementById("file-used");
		var fileLength = target.files.length;

		if (fileLength !== 0) {
			var img = target.files[0].type.match(/\.png|\.jpg|\.jpeg|image\/png|image\/jpg|image\/jpeg/);
		}

		if (fileLength === 0) {
			this.error = 'No file selected';
		} else if (!img) {
			this.error = 'Please upload image file';
		} else {
			this.error = '';
			var selectedFile = target.files[0];
			var data = {
				selectedFile,
				uploader,
				progress,
				alert,
				file_name_element
			}
			this.imageService.imageUpload(data);
			target.value = '';
		}
	}

	filechange(event: Event) {
		var input = <HTMLInputElement>event.target;
		console.log(input.files);
		this.imageService.getImageSize(input.files[0]).then((dims) => {
			console.log(dims);
		});
		var file_name_element = <HTMLDivElement>document.getElementById("file-used");
		var alert = <HTMLDivElement>document.getElementById("hidden");
		var file = input.files[0];
		file_name_element.innerHTML = file.name;
		alert.style.display = 'none';
		this.error = '';
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/media-selector/media-selector.component.ts